import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';

const links = [
  { label: 'خانه', href: '/' },
  { label: 'ثبت آگهی', href: '/post-ad' },
  { label: 'آگهی‌های من', href: '/my-ads' },
  { label: 'پروفایل', href: '/profile' },
];

const categories = [
  { label: 'املاک', href: '/?category=1' },
  { label: 'وسایل نقلیه', href: '/?category=24' },
  { label: 'کالای دیجیتال', href: '/?category=33' },
  { label: 'خانه و آشپزخانه', href: '/?category=55' },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0f1c36',
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto',
        direction: 'rtl',
        fontFamily: 'Vazirmatn',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>

          {/* Brand column */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h5"
              fontWeight={900}
              sx={{ color: '#60a5fa', letterSpacing: '0.04em', mb: 1.5 }}
            >
              آگه‌جو
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 2, maxWidth: 280 }}>
              پلتفرم آگهی آنلاین برای خرید، فروش، اجاره و ارائه خدمات. سریع، رایگان و در دسترس همه.
            </Typography>
            <Box sx={{ mt: 2.5, display: 'flex', gap: 1.5 }}>
              {/* Placeholder social icons as simple styled boxes */}
              {['📱', '📷', '✉️'].map((icon, i) => (
                <Box
                  key={i}
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255,255,255,0.07)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    '&:hover': { bgcolor: 'rgba(96,165,250,0.18)' },
                  }}
                >
                  {icon}
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Quick links */}
          <Grid item xs={6} md={2.5}>
            <Typography variant="subtitle2" fontWeight={800} sx={{ color: 'rgba(255,255,255,0.9)', mb: 2, letterSpacing: '0.02em' }}>
              دسترسی سریع
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
              {links.map(link => (
                <a key={link.href} href={link.href} style={{ textDecoration: 'none' }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'rgba(255,255,255,0.55)',
                      transition: 'color 0.15s',
                      '&:hover': { color: '#60a5fa' },
                    }}
                  >
                    {link.label}
                  </Typography>
                </a>
              ))}
            </Box>
          </Grid>

          {/* Categories */}
          <Grid item xs={6} md={2.5}>
            <Typography variant="subtitle2" fontWeight={800} sx={{ color: 'rgba(255,255,255,0.9)', mb: 2, letterSpacing: '0.02em' }}>
              دسته‌بندی‌ها
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2 }}>
              {categories.map(cat => (
                <a key={cat.href} href={cat.href} style={{ textDecoration: 'none' }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'rgba(255,255,255,0.55)',
                      transition: 'color 0.15s',
                      '&:hover': { color: '#60a5fa' },
                    }}
                  >
                    {cat.label}
                  </Typography>
                </a>
              ))}
            </Box>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle2" fontWeight={800} sx={{ color: 'rgba(255,255,255,0.9)', mb: 2, letterSpacing: '0.02em' }}>
              تماس با ما
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.4 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span style={{ fontSize: 16 }}>📧</span>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.55)' }}>
                  info@agahjoo.ir
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span style={{ fontSize: 16 }}>🌐</span>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.55)' }}>
                  agahjoo.ir
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span style={{ fontSize: 16 }}>🇮🇷</span>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.55)' }}>
                  ایران
                </Typography>
              </Box>
            </Box>
          </Grid>

        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.08)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)' }}>
            © ۱۴۰۴ آگه‌جو — تمام حقوق محفوظ است
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.25)' }}>
           اتصال خریداران و فروشندگان در یک بستر امن
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
